
export default function Products() {
  return (
    <section id="products" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-24">
          <div className="inline-flex items-center justify-center w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-full mb-6">
            <i className="ri-apple-fill text-white text-2xl"></i>
          </div>
          <h2 className="text-6xl font-bold text-[#0F172A]">Our Products</h2>
        </div>

        <div className="grid grid-cols-3 gap-6" data-product-shop>
          <div className="col-span-1 rounded-3xl bg-gradient-to-br from-blue-400 to-cyan-300 p-10 shadow-xl h-[420px] flex flex-col justify-between">
            <div>
              <h3 className="text-3xl font-bold text-white mb-4">VPN Application</h3>
              <p className="text-white/80 text-base leading-relaxed">
                Secure your connection with our advanced VPN solution. Browse privately and access content from anywhere in the world.
              </p>
            </div>
            <div className="flex justify-center">
              <img 
                src="https://public.readdy.ai/ai/img_res/e15967c767874d5032768fd72e2a84f2.jpg" 
                alt="VPN App" 
                className="w-48 h-auto object-contain"
              />
            </div>
          </div>

          <div className="col-span-2 flex flex-col gap-6">
            <div className="rounded-3xl bg-gradient-to-br from-emerald-200 to-teal-100 p-10 shadow-xl h-[198px] flex items-center justify-between">
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-emerald-900 mb-3">Cleaner App</h3>
                <p className="text-emerald-800 text-sm leading-relaxed max-w-md">
                  Optimize your device performance by removing junk files, managing storage, and keeping your iOS device running smoothly.
                </p>
              </div>
              <div className="flex-shrink-0">
                <img 
                  src="https://readdy.ai/api/search-image?query=iPhone%20displaying%20cleaner%20application%20interface%20showing%20storage%20analysis%2C%20file%20management%20screen%2C%20green%20and%20white%20UI%20design%2C%20clean%20simple%20background%2C%20professional%20product%20photography&width=250&height=500&seq=sylpa-cleaner-1&orientation=portrait" 
                  alt="Cleaner App" 
                  className="w-32 h-auto object-contain"
                />
              </div>
            </div>

            <div className="rounded-3xl bg-gradient-to-br from-rose-200 to-pink-100 p-10 shadow-xl h-[198px] flex items-center justify-between">
              <div className="flex-1">
                <h3 className="text-2xl font-bold text-rose-900 mb-3">Security Tools</h3>
                <p className="text-rose-800 text-sm leading-relaxed max-w-md">
                  Comprehensive security features to protect your personal data, detect threats, and ensure your privacy on iOS devices.
                </p>
              </div>
              <div className="flex-shrink-0">
                <img 
                  src="https://readdy.ai/api/search-image?query=iPhone%20showing%20security%20application%20interface%20with%20shield%20icon%2C%20privacy%20protection%20features%2C%20pink%20and%20white%20UI%20design%2C%20clean%20background%2C%20professional%20product%20shot&width=250&height=500&seq=sylpa-security-1&orientation=portrait" 
                  alt="Security Tools" 
                  className="w-32 h-auto object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
